<template>
    <div class="ava-initials flex-shrink-0" :class="`${classes} ${getInitialsClass}`">
        <i v-if="isDraftConv" class="fa-regular fa-comment-dots"></i>
        <i v-else-if="initialsType == AvaInitialsType.Group" class="fas fa-users"></i>
        <img v-else-if="imageUrl" class="w-100 h-100 rounded-circle" :src="imageUrl" alt="Profile Picture" />
        <!-- commenting for future usecase -->
        <!-- <template v-if="isAxxessConversation">
            <img src="../../../../assets/images/favicon-96x96.png" width="32px" />
        </template> -->
        <span v-else>{{ formatUserInitials(user) }}</span>
    </div>
</template>

<style src="./AvaInitials.scss"></style>
<script lang="ts" src="./AvaInitials.ts"></script>
